import { axiosInstance } from '../../../shared/api';

export async function clearChatHistory() {
	try {
		const response = await axiosInstance.delete(`chat/history`);
		if (response.status === 200) {
			return response.data;
		}
	} catch (error) {
		console.error('Error clearing chat history:', error);
		throw error;
	}
}
